import React, { useState, useEffect } from "react";
import "../styles/LoanEmiCalculator.css";
import { jsPDF } from "jspdf";

function EmiCalculator() {

const [loanAmount,setLoanAmount]=useState(500000);
const [interestRate,setInterestRate]=useState(8.5);
const [tenure,setTenure]=useState(5);

const [emi,setEmi]=useState(0);
const [totalInterest,setTotalInterest]=useState(0);
const [totalPayment,setTotalPayment]=useState(0);
const [schedule,setSchedule]=useState([]);

useEffect(()=>{
calculateEMI();
},[loanAmount,interestRate,tenure]);

const calculateEMI=()=>{

let P=loanAmount;
let r=interestRate/12/100;
let n=tenure*12;

let EMI=(P*r*Math.pow(1+r,n))/(Math.pow(1+r,n)-1);

let totalPay=EMI*n;
let interest=totalPay-P;

setEmi(Math.round(EMI));
setTotalInterest(Math.round(interest));
setTotalPayment(Math.round(totalPay));

generateSchedule(P,r,n,EMI);

};

const generateSchedule=(P,r,n,EMI)=>{

let balance=P;
let table=[];

for(let i=1;i<=n;i++){

let interest=balance*r;
let principal=EMI-interest;
balance-=principal;

table.push({
month:i,
emi:Math.round(EMI),
principal:Math.round(principal),
interest:Math.round(interest),
balance:Math.max(0,Math.round(balance))
});

}

setSchedule(table);

};

const downloadReport = () => {

const doc = new jsPDF();

doc.setFontSize(22);
doc.text("Loan EMI Report", 20, 20);

doc.setFontSize(12);

doc.text(`Loan Amount: ₹ ${loanAmount}`,20,40);
doc.text(`Interest Rate: ${interestRate}%`,20,50);
doc.text(`Loan Tenure: ${tenure} Years`,20,60);

doc.text(`Monthly EMI: ₹ ${emi}`,20,80);
doc.text(`Total Interest: ₹ ${totalInterest}`,20,90);
doc.text(`Total Payment: ₹ ${totalPayment}`,20,100);

doc.text("Repayment Schedule (First 12 Months)",20,120);

let y=130;

schedule.slice(0,12).forEach((row)=>{
doc.text(
`Month ${row.month} | EMI: ₹${row.emi} | Principal: ₹${row.principal} | Interest: ₹${row.interest} | Balance: ₹${row.balance}`,
20,
y
);
y+=8;
});

doc.save("EMI_Report.pdf");

};

return(

<div className="emi-wrapper">

<section className="emi-hero">
<h1>Loan EMI Calculator</h1>
<p>Plan your loans smarter with our advanced EMI calculator</p>
</section>

<div className="loan-tabs">

<button onClick={()=>setInterestRate(8.5)}>Home Loan</button>
<button onClick={()=>setInterestRate(10.5)}>Car Loan</button>
<button onClick={()=>setInterestRate(14)}>Personal Loan</button>
<button onClick={()=>setInterestRate(8.5)}>Gold Loan</button>

</div>

<div className="emi-container">

<div className="emi-inputs">

<h3>Loan Details</h3>

<label>Loan Amount</label>
<input type="range"
min="50000"
max="2000000"
step="10000"
value={loanAmount}
onChange={(e)=>setLoanAmount(e.target.value)}
/>
<p>₹ {loanAmount}</p>

<label>Interest Rate (%)</label>
<input type="range"
min="5"
max="20"
step="0.1"
value={interestRate}
onChange={(e)=>setInterestRate(e.target.value)}
/>
<p>{interestRate}%</p>

<label>Loan Tenure (Years)</label>
<input type="range"
min="1"
max="20"
value={tenure}
onChange={(e)=>setTenure(e.target.value)}
/>
<p>{tenure} Years</p>

</div>

<div className="emi-results">

<h3>Loan Summary</h3>

<div className="result-item">
<span>Monthly EMI</span>
<strong>₹ {emi}</strong>
</div>

<div className="result-item">
<span>Principal</span>
<strong>₹ {loanAmount}</strong>
</div>

<div className="result-item">
<span>Total Interest</span>
<strong>₹ {totalInterest}</strong>
</div>

<div className="result-item">
<span>Total Payment</span>
<strong>₹ {totalPayment}</strong>
</div>

<button className="emi-download-btn" onClick={downloadReport}>
Download EMI Report
</button>

<a href="/loans" className="apply-btn">
Apply Now
</a>

</div>

</div>

<section className="emi-breakdown">

<h2>EMI Payment Breakdown</h2>

<div className="breakdown-chart">

<div
className="donut"
style={{
background:`conic-gradient(
#27a3d7 ${(loanAmount/totalPayment)*360}deg,
#faa727 0deg
)`
}}
></div>

<div className="legend">

<div>
<span className="box principal"></span>
Principal
</div>

<div>
<span className="box interest"></span>
Interest
</div>

</div>

</div>

</section>

<section className="emi-table-section">

<h2>Repayment Schedule</h2>

<div className="table-container">

<table>

<thead>

<tr>
<th>Month</th>
<th>EMI</th>
<th>Principal</th>
<th>Interest</th>
<th>Balance</th>
</tr>

</thead>

<tbody>

{schedule.slice(0,12).map((row,index)=>(

<tr key={index}>
<td>{row.month}</td>
<td>₹ {row.emi}</td>
<td>₹ {row.principal}</td>
<td>₹ {row.interest}</td>
<td>₹ {row.balance}</td>
</tr>

))}

</tbody>

</table>

</div>

</section>

<section className="emi-tips">

<h3>Tips to Reduce EMI</h3>

<ul>
<li>Increase loan tenure to reduce monthly EMI</li>
<li>Make higher down payment</li>
<li>Choose lower interest loan options</li>
<li>Prepay loan when possible</li>
</ul>

</section>

</div>

);

}

export default EmiCalculator;